(function ($) {

    this.init = function () {

        this.OLB();
    };


    this.OLB = function () {


        // SET UP BUTTON CLICKS
        $("#OLBLoginButtonDesktop").click(clickOpen);
        $("#OLBLoginButtonMobile").click(clickMobileOpen);
        $("#OLBSkip").click(clickClose);

        // On change of these fields, enter that stuff into the hidden fields

        // on submit button press, hit submit of that mian button.
        //        $(".onlinebanking-right submitbutton").on("click", clickSubmit);

    }
    function clickSubmit() {
        $("input[type='submit']").click();
    }
    function clickOpen() {
        if ($(".onlinebanking").hasClass("open-olb")) {
            closeOnlineBanking();
        } else {
            expandOnlineBanking();
        }
    }
    function clickMobileOpen() {
        if ($(".onlinebanking").hasClass("open-mobile-olb")) {
            closeMobileOnlineBanking();
        } else {
            expandMobileOnlineBanking();
        }
    }
    function clickClose() {
        if ($(".onlinebanking").hasClass("open-olb")) {
            $(".onlinebanking a").first().focus();
        }
        else if ($(".onlinebanking").hasClass("open-mobile-olb")) {
            $(".onlinebanking a").first().focus();
        }
        else {
            expandOnlineBanking();
        }
    }
    function expandOnlineBanking() {
        $("#OLBLoginButtonDesktop").attr("aria-expanded", true);
        $(".onlinebanking").addClass("open-olb");
        $(".onlinebanking a").first().focus();
    }
    function closeOnlineBanking() {
        $("#OLBLoginButtonDesktop").attr("aria-expanded", false);
        $(".onlinebanking").removeClass("open-olb");
    }
    function expandMobileOnlineBanking() {
        $("#OLBLoginButtonMobile").attr("aria-expanded", true);
        $(".onlinebanking").addClass("open-mobile-olb");
        $(".onlinebanking a").first().focus();
    }
    function closeMobileOnlineBanking() {
        $("#OLBLoginButtonMobile").attr("aria-expanded", false);
        $(".onlinebanking").removeClass("open-mobile-olb");
    }
    this.init();

})(jQuery);